module.exports = __webpack_public_path__ + "static/media/1-2-3.1042c36b.png";